import { useContext } from "react";
import { PrescriptionWithProduct } from "src/api/types";
import { LatestPrescriptionContext } from "./LatestPrescriptionProvider";

export function useLatestPrescription<T>(
  selector: (prescription: PrescriptionWithProduct) => T
) {
  const prescription = useContext(LatestPrescriptionContext);

  if (prescription == null) {
    return null;
  }

  return selector(prescription);
}
